import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as d, normalizeClass as s, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconListChecks",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, l, _, f, a) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--list-checks"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "List Checks",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.5 3a.5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Zm0 3a.5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Zm0 3a.5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5ZM2.646 2.146a.5.5 0 1 1 .708.708l-1 1a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 2.793l.646-.647Zm0 3a.5.5 0 1 1 .708.708l-1 1a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 5.793l.646-.647Zm0 3a.5.5 0 1 1 .708.708l-1 1a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 8.793l.646-.647Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ o(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=list-checks.js.map
